import React from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer, LabelList
} from 'recharts';
import Typography from "@mui/material/Typography";
import {UserActivityTypes} from "../../types";
import {Box} from "@mui/material";
import {getWeekDisplay} from "../../helpers/weekYearDisplayFormat";

interface Props{
    data: UserActivityTypes.WeeklyActivityData
}

interface ChartDataPoint {
    date: string;
    value: number;
}

const transformToChartData = (data: UserActivityTypes.WeeklyActivityData): ChartDataPoint[] => {
    // Create a map to group data by weekYear
    const weeklyData: Record<string, number[]> = {};

    let totalTeamCount = Object.keys(data).length
    let allWeekYears: string[] = [];
    // Iterate through each team's data
    Object.values(data).forEach(teamDataArray => {
        teamDataArray.forEach(weekData => {
            const weekYear = weekData.weekYear;
            allWeekYears.push(weekYear)
            const percentage = parseFloat(weekData.activeUserPercentage);

            if (!weeklyData[weekYear]) {
                weeklyData[weekYear] = [];
            }
            weeklyData[weekYear].push(percentage);
        });

    });

    // Calculate averages and create chart data
    const chartData: ChartDataPoint[] = Object.entries(weeklyData).map(([weekYear, percentages]) => {
        const average = percentages.reduce((sum, val) => sum + val, 0) / totalTeamCount;
        return {
            date: getWeekDisplay(weekYear,allWeekYears),
            value: Math.round(average * 100) / 100 // Round to 2 decimal places
        };
    });

    return chartData;
}

const TeamCumulativeActiveUserPercentageLineChart : React.FC<Props> = ({data}) => {
    const chartData: ChartDataPoint[] = transformToChartData(data);
    return (
        <div style={{ width: '100%', height: 300 }}>
            {chartData.length === 0 ? (

                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', margin: 'auto' }}>
                    <Typography align={"center"} fontSize={16} fontWeight={600}>
                        No data available
                    </Typography>
                </Box>
            ) : (
                <>
                    <Typography align={"center"}  fontWeight={400} fontSize={16} mb={2}>Weekly Active Users Last 12 weeks</Typography>
                    <ResponsiveContainer width="100%" height="80%">
                        <LineChart
                            data={chartData}
                        >
                            <XAxis
                                dataKey="date"
                                tick={{ fontSize: 12 }}
                                padding={{ left: 30, right: 30 }}
                            />
                            <YAxis
                                tick={false} // Hide all tick texts
                                tickLine={false} // Hide tick lines
                                domain={[0, 100]}
                            />
                            <Tooltip
                                formatter={(value) => [`${Math.round(Number(value))}%`, 'Percentage']}
                                labelFormatter={(label) => `Date: ${label}`}
                            />
                            <Line
                                type="linear"
                                dataKey="value"
                                stroke="#ccc"
                                dot={{
                                    r: 8,
                                    fill: '#11A7E2',
                                    stroke: '#ccc',
                                    strokeWidth: 1
                                }}
                            >
                                <LabelList
                                    dataKey="value"
                                    position="top"
                                    formatter={(value : any) => `${Math.round(Number(value))}%`}
                                    style={{ fill: '#000', fontWeight: 400, fontSize: 14, transform: 'translateY(-8px)'}}
                                />
                            </Line>
                        </LineChart>
                    </ResponsiveContainer>
                </>
            )}
        </div>
    );
};

export default TeamCumulativeActiveUserPercentageLineChart;